var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bottom-ui" }, [
    _c("ul", { staticClass: "bottom-ui-btn" }, [
      _vm.$parent.mirroringCurrentPage !== 1
        ? _c("li", { staticClass: "prev-li" }, [
            _c(
              "button",
              {
                staticClass: "prev-btn",
                on: {
                  click: function ($event) {
                    return _vm.$emit("prev")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("mirroring.prev")))]
            ),
          ])
        : _vm._e(),
      _vm.$parent.mirroringCurrentPage !== _vm.$parent.mirroringTotalPage
        ? _c("li", { staticClass: "next-li" }, [
            _c(
              "button",
              {
                staticClass: "next-btn",
                on: {
                  click: function ($event) {
                    return _vm.$emit("next")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("mirroring.next")))]
            ),
          ])
        : _c("li", { staticClass: "next-li" }, [
            _c(
              "button",
              {
                staticClass: "next-btn",
                on: {
                  click: function ($event) {
                    return _vm.$emit("submit")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("mirroring.submit")))]
            ),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }